import React, { Component } from "react";
import { GetUser } from "../util/Helper";
import ImageOrInitial from "./ImageOrInitial";

class UserDetails extends Component {
  constructor(props) {
      super(props);
      this.state = {
        user:{},
      };

      //document.title = "Home"
  }
  componentDidMount() {
    this.setState({user:GetUser()});
  }
  render() {
    if(!this.state.user){
      return null;
    }
    return (
        <a className ="userDetails" href="/user">
          <ImageOrInitial name={this.state.user.name} className="udIcon"/>
          <div>
            <span>{this.state.user.name}</span>
            <span className="udCompany">{this.state.user.company_name}</span>
           </div>
        </a>
    );
  }
}
 
export default UserDetails;